import React from 'react';
import PropTypes from 'prop-types';
import { createModal } from 'react-modal-promise';
import '../ReactModal/reactModal.scss';

const prodigyModal = ({ close }) => (
  <div className="p-modal-container">
    <div className="p-modal">
      <div className="p-modal-text">
        <h2>Are you sure you want to refund this deposit?</h2>
      </div>
      <i
        onClick={() => close(false)}
        className="modal-close close icon"
        alt="close"
      />
      <div className="p-modal-body">
        <p>The deposit amount will be returned to the customer.</p>
      </div>
      <div className="p-modal-actions">
        <button
          className="btn btn-danger btn-large btn-large-default"
          onClick={() => close(true)}
        >
          Refund
        </button>
        <button
          className="btn btn-default btn-large"
          onClick={() => close(false)}
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
);

prodigyModal.propTypes = {
  close: PropTypes.func,
};

const DepositRefundModal = createModal(prodigyModal);

export default DepositRefundModal;
